// mutations
const CAFETERIA_DELIVERIES_ALL = (state, cafeteriaDeliveries) => {
  if (cafeteriaDeliveries.code === 1) {
    state.cafeteriaDeliveries = cafeteriaDeliveries.data
    state.status = 'success'
  } else {
    alert(cafeteriaDeliveries.message)
    state.status = 'error'
  }
}

const CAFETERIA_DELIVERIES_FORM = (state, cafeteriaDeliveries) => {
  if (cafeteriaDeliveries.code === 1) {
    state.cafeteriaDeliveries = cafeteriaDeliveries.data
    state.status = 'success'
  } else {
    alert(cafeteriaDeliveries.message)
    state.status = 'error'
  }
}

const CAFETERIA_DELIVERIES_SHOW = (state, cafeteriaDeliveries) => {
  if (cafeteriaDeliveries.code === 1) {
    state.deliveries = cafeteriaDeliveries.data
    state.status = 'success'
  } else {
    alert(cafeteriaDeliveries.message)
    state.status = 'error'
  }
}

const CAFETERIA_DELIVERIES_CREATE = (state, cafeteriaDeliveries) => {
  if (cafeteriaDeliveries.code === 1) {
    state.cafeteriaDeliveries = cafeteriaDeliveries.data
    state.status = 'success'
    alert(cafeteriaDeliveries.message)
  } else {
    alert(cafeteriaDeliveries.message)
    state.status = 'error'
  }
}

const CAFETERIA_DELIVERIES_UPDATE = (state, cafeteriaDeliveries) => {
  if (cafeteriaDeliveries.code === 1) {
    state.cafeteriaDeliveries = cafeteriaDeliveries.data
    state.status = 'success'
    alert(cafeteriaDeliveries.message)
  } else {
    alert(cafeteriaDeliveries.message)
    state.status = 'error'
  }
}

const CAFETERIA_DELIVERIES_DELETE = (state, cafeteriaDeliveries) => {
  if (cafeteriaDeliveries.code === 1) {
    state.cafeteriaDeliveries = cafeteriaDeliveries.data
    state.status = 'success'
    alert(cafeteriaDeliveries.message)
  } else {
    alert(cafeteriaDeliveries.message)
    state.status = 'error'
  }
}

export default {
  CAFETERIA_DELIVERIES_ALL,
  CAFETERIA_DELIVERIES_FORM,
  CAFETERIA_DELIVERIES_SHOW,
  CAFETERIA_DELIVERIES_CREATE,
  CAFETERIA_DELIVERIES_UPDATE,
  CAFETERIA_DELIVERIES_DELETE
}



// WEBPACK FOOTER //
// ./src/store/modules/cafeteria/deliveries/mutations.js